export default "__VITE_ASSET__DFPQHv3k__"